<template>
  <div class="page page__list">
    <search-bar
      @search="onSearch"
      name="pi_inoutno,pi_whname,pi_remark"
      placeholder="输入单据编号、仓库、备注进行查找"
      ref="searchBar"
    />
    <filter-bar @change="onSearch" :filters="filters" ref="filterBar" />
    <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
      <router-link
        class="weui-cell weui-cell_access"
        v-for="item in items"
        :key="item.id"
        :to="'/stock/move/'+item.id"
      >
        <div class="weui-cell__bd">
          <p>{{item.pi_inoutno}}</p>
          <p class="list-item-muted">{{item.pi_date}}</p>
        </div>
        <div class="weui-cell__ft">
          <p v-format="'¥#,##0.00'">{{item.pi_costtotal}}</p>
          <span
            class="list-item-status"
            :class="{'warning':item.pi_status!='已审核'}"
          >{{item.pi_status}}</span>
        </div>
      </router-link>
    </scroll-list>
    <div class="list-footer">
      <label class="list-footer__label">合计：{{items.length}}笔</label>
      <em class="list-footer__value" v-format="'¥#,##0.00'">{{getTotal('pi_costtotal')}}</em>
    </div>
    <add-button to="/stock/move_edit" />
  </div>
</template>

<script>
import SearchBar from "@/components/SearchBar.vue";
import FilterBar from "@/components/FilterBar.vue";
import ScrollList from "@/components/ScrollList.vue";
import AddButton from "@/components/button/Add.vue";
import list from "@/mixins/list.js";

export default {
  components: {
    SearchBar,
    FilterBar,
    ScrollList,
    AddButton
  },
  mixins: [list],
  data() {
    return {
      listUrl: "/api/storage/prodinout/list",
      params: {
        caller: 'AppropriationInOut'
      },
      filters: [
        {
          type: "date",
          name: "pi_date"
        },
        {
          type: "condition",
          label: "状态",
          value: -1,
          options: [
            {
              value: -1,
              label: "全部",
              condition: "pi_class='MOVEOUT' and ifnull(pi_otherkind,'') not in ('借货单','还货单')"
            },
            {
              value: 1,
              label: "待审核",
              condition: "pi_class = 'MOVEOUT' and ifnull(pi_otherkind,'') not in ('借货单','还货单') and pi_statuscode<>'AUDITED'"
            },
            {
              value: 2,
              label: "已审核",
              condition: "pi_class = 'MOVEOUT' and ifnull(pi_otherkind,'') not in ('借货单','还货单') and pi_statuscode='AUDITED'"
            }
          ]
        }
      ]
    };
  }
};
</script>